<div class="action-arrow__content">
	<a class="action-icon action-icon-active">
		<i class="fas fa-trash active" (click)="onDeleteCIJobType()"></i>
	</a>
	<a class="action-icon action-icon-active" (click)="onEditCIJobType()">
		<i class="fas fa-edit active"></i>
	</a>
</div>
